











import Vue from 'vue'
import FilterDropdown from '@/pages/common/filter-dropdown/FilterDropdown.vue'
import {
  statusDropdownModule,
  $status,
} from '@/pages/common/dropdowns/courses/status-dropdown/status-dropdown.model'
import { DropdownItem } from '@/pages/common/types'

export default Vue.extend({
  components: {
    FilterDropdown,
  },
  props: {
    label: {
      type: String,
      default: 'Статус',
    },
  },
  effector: {
    $status,
    ...statusDropdownModule.store,
  },
  methods: {
    ...statusDropdownModule.methods,
    onSelectItem(item: DropdownItem | null) {
      this.$emit('setItem', item ? item.name : null)
    },
  },
})
